import { ColumnState } from 'ag-grid-community';
import { difference } from 'lodash';
import { ColumnOrder } from './types';

export const withValidColumnOrderProps = ({
  colId,
  width,
  hide,
  pinned,
  sort,
  sortIndex,
}: ColumnState | ColumnOrder): ColumnOrder => ({
  colId,
  width,
  hide: hide ?? null,
  pinned: pinned ?? null,
  sort: sort ?? null,
  sortIndex: sortIndex ?? null,
});

export const asColumnOrder = (
  columnsOrder: ColumnState[] = [],
): ColumnOrder[] => {
  return columnsOrder.map(withValidColumnOrderProps);
};

export const cleanUpColumnOrder =
  (defaultColumnOrder: ColumnOrder[]) =>
  (columnOrder: ColumnOrder[]): ColumnOrder[] => {
    const defaultColumns = defaultColumnOrder.map((x) => x.colId);
    const currentColumns = columnOrder.map((x) => x.colId);
    const newlyAddedColumns = difference(defaultColumns, currentColumns);

    const isAllColumnsVisible = columnOrder.every((col) => col.hide === false);

    return newlyAddedColumns.reduce(
      (finalOrder, columnName) => {
        const indexOfColumn = defaultColumnOrder.findIndex(
          (column) => column.colId === columnName,
        );

        if (indexOfColumn === -1) {
          return finalOrder;
        }

        finalOrder.splice(
          indexOfColumn,
          0,
          withValidColumnOrderProps({
            ...defaultColumnOrder[indexOfColumn],
            hide: !isAllColumnsVisible,
          }),
        );

        return finalOrder;
      },
      columnOrder.filter((x) => defaultColumns.includes(x.colId)),
    );
  };
